import * as React from "react"
// import { useLocation } from '@reach/router'

const HeadCSS = (props) => {
	// const location = useLocation()
	// const pageCss = ( !/\/knowledge\//.test(location.pathname) ) ?
   	// 	'/css'+ location.pathname +'page.min.css' : false
	
	// let pageType = ( props.data.wpPage ) ? 
	// 	props.data.wpPage : props.data.wpPost
	// let langCode = ( pageType.language ) ? 
	// 	pageType.language.slug : props.data.wpCategory.language.slug || 'en'

	return(
		<>
			{
				// pageCss &&
				// <link rel="stylesheet" data-chead href={pageCss} />
			}

			{/* <link rel="stylesheet" data-chead 
				href={'/css/header-'+ langCode +'.min.css'} /> */}
			{/* <link rel="stylesheet" data-chead 
				href={'/css/footer-'+ langCode +'.min.css'}  /> */}
			
		</>
	)
}

export default HeadCSS